import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { IOrderMSNote } from '~/types/note/models'

export const {
  getNoteListData: getOrderMSNoteListData,
  getNoteDataById: getOrderMSNoteDataById,
  getNoteListDataByParentId: getOrderMSNoteListDataByMOMSId,
} = makeNoteMockData<IOrderMSNote>({
  entityName: 'orderMasterService',
  storageKeyPrefix: 'orderms',
})
